import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

import Typography from "../../../../components/Typography";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as SearchCheckIcon } from "../../../../build/images/nps-dashboard-icons/search_check.svg";
import { ReactComponent as PersonSearchIcon } from "../../../../build/images/nps-dashboard-icons/person_search.svg";
import { ReactComponent as SupervisorAccountIcon } from "../../../../build/images/nps-dashboard-icons/supervisor_account.svg";
import { ReactComponent as ClockLoaderIcon } from "../../../../build/images/nps-dashboard-icons/clock_loader_10.svg";
import { ReactComponent as HistoryIcon } from "../../../../build/images/nps-dashboard-icons/history.svg";

import "./nps-date-one.css";
import Paperplane from "../../../Loading/Paperplane";
import CardChannelBased from "../CardChannelBased";
import axios from "axios";

export default function NpsDateOne({
  setIsLoadingSurveyInfos,
  setSurveyInfosFromDateOne,
}) {
  const filtersDashboard = useSelector((state) => state.npsfilters);

  //   const [surveyData, setSurveyData] = useState(exSurveyData);
  const [surveyInfos, setSurveyInfos] = useState({
    enviadas: "0",
    respondidas: 0,
    clientes: 0,
    porcentagemClientes: 0,
    tempMedio: "0",
  });
  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [loading, setLoading] = useState(false);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [dataChannelBased, setDataChannelBased] = useState({
    sms: { midiaId: 12, sent: 0, answered: 0 },
    email: { midiaId: 3, sent: 0, answered: 0 },
    whatsapp: { midiaId: 5, sent: 0, answered: 0 },
    rcs: { midiaId: 15, sent: 0, answered: 0 },
  });
  const [loadingDataChannelBased, setLoadingDataChannelBased] = useState(false);

  const surveyData = [
    {
      icon: <SearchCheckIcon />,
      number: surveyInfos.enviadas,
      information: "Pesquisas enviadas",
      class: "sent-surveys",
    },
    /*
    {
      icon: <PersonSearchIcon />,
      number: surveyInfos.respondidas,
      information: "Pesquisas respondidas",
      class: "answered-surveys",
    },
    */
    {
      icon: <SupervisorAccountIcon />,
      number: surveyInfos.clientes,
      information: "Pesquisas respondidas",
      class: "customers-responded-survey",
    },
    {
      icon: <ClockLoaderIcon />,
      number: surveyInfos.porcentagemClientes,
      information: "% de respostas",
      class: "customer-percentage",
    },
    {
      icon: <HistoryIcon />,
      number: surveyInfos.tempMedio,
      information: "Tempo médio de respostas da pesquisa",
      class: "average-response-time",
    },
  ];

  function formatNumberToString(value) {
    let formatedValue = "--";
    const valueNumber = Number(value);
    if (valueNumber || valueNumber === 0) {
      formatedValue = valueNumber.toLocaleString("pt-BR");
    }

    return formatedValue;
  }

  async function getDataChannelBased(source) {
    let updatedData = {
      sms: { midiaId: 12, sent: 0, answered: 0 },
      email: { midiaId: 3, sent: 0, answered: 0 },
      whatsapp: { midiaId: 5, sent: 0, answered: 0 },
      rcs: { midiaId: 15, sent: 0, answered: 0 },
    };
    const response = await APIDashboard.getSentSurveysMidia(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      source,
      setLoadingDataChannelBased
    );
    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.length
    ) {
      response.data.forEach((midiaInfo) => {
        switch (midiaInfo.id_midia) {
          case 12:
            updatedData.sms = {
              midiaId: 12,
              sent: midiaInfo.qtde_enviada,
              answered: midiaInfo.qtde_respondida,
            };
            break;
          case 3:
            updatedData.email = {
              midiaId: 3,
              sent: midiaInfo.qtde_enviada,
              answered: midiaInfo.qtde_respondida,
            };
            break;
          case 5:
            updatedData.whatsapp = {
              midiaId: 5,
              sent: midiaInfo.qtde_enviada,
              answered: midiaInfo.qtde_respondida,
            };
            break;
          case 15:
            updatedData.rcs = {
              midiaId: 1,
              sent: midiaInfo.qtde_enviada,
              answered: midiaInfo.qtde_respondida,
            };
            break;
          default:
            break;
        }
      });
    }

    setDataChannelBased(updatedData);
  }

  async function getSentSurveys() {
    setIsLoadingSurveyInfos(true);
    setLoading(true);

    const response = await APIDashboard.getSentSurveys(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;
      const newSurveyData = data.map((datum) => ({
        enviadas: datum.qtde_enviada,
        respondidas: datum.qtde_respondida,
        clientes: datum.qtde_respondida,
        porcentagemClientes:
          Number(datum.qtde_enviada) > 0
            ? ((datum.qtde_respondida / datum.qtde_enviada) * 100).toFixed(2)
            : 0,
        tempMedio: datum.media_resposta_pesquisa
          ? handleTempMed(datum.media_resposta_pesquisa)
          : "0",
      }));

      setSurveyInfos(newSurveyData[0]);
      setSurveyInfosFromDateOne(newSurveyData[0]);
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }

    setIsLoadingSurveyInfos(false);
    setLoading(false);
  }

  /*
  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${ano.replaceAll("0", "")} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = mes.replaceAll("0", "");
      return `${mes.replaceAll("0", "")} ${
        corrigirMeses > 1 ? "meses" : "mês"
      }`;
    } else if (dia !== "00") {
      return `${dia.replaceAll("0", "")} dia(s)`;
    } else if (hora !== "00") {
      return `${hora.replaceAll("0", "")} hora(s)`;
    } else if (minuto !== "00") {
      return `${minuto.replaceAll("0", "")} minuto(s)`;
    } else if (segundo !== "00") {
      return `${segundo.replaceAll("0", "")} segundo(s)`;
    }
  }
  */

  function handleTempMed(tempMed) {
    // ANO | MES | DIA | HORA | MINUTO | SEGUNDO
    const cutTime = tempMed.split("|");
    let ano = cutTime[0];
    let mes = cutTime[1];
    let dia = cutTime[2];
    let hora = cutTime[3];
    let minuto = cutTime[4];
    let segundo = cutTime[5];

    if (ano !== "0000") {
      return `${Number(ano)} ano(s)`;
    } else if (mes !== "00") {
      const corrigirMeses = Number(mes);
      return `${Number(mes)} ${corrigirMeses > 1 ? "meses" : "mês"}`;
    } else if (dia !== "00") {
      return `${Number(dia)} dia(s)`;
    } else if (hora !== "00") {
      return `${Number(hora)} hora(s)`;
    } else if (minuto !== "00") {
      return `${Number(minuto)} minuto(s)`;
    } else if (segundo !== "00") {
      return `${Number(segundo)} segundo(s)`;
    }
  }

  useEffect(() => {
    getSentSurveys();
    setDispareFilter(true);
  }, []);

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (filtersDashboard.active && dispareFilter) {
      getSentSurveys();
    }

    getDataChannelBased(source);

    return () => {
      source.cancel("Operation canceled by the user.");
    };
  }, [filtersDashboard]);

  return (
    <section className="nps-date-one-holder">
      <section className="nps-date-one-holder__item">
        <header className="nps-date-one__header">
          <h4>Disparo baseado no cliente</h4>
        </header>
        <section className="nps-date-one">
          {loading ? (
            <Paperplane className="nps-date-one__loading" />
          ) : (
            surveyData.map((data, index) => (
              <div key={index} className={data.class}>
                <span className={`${data.class}__icon`}>{data.icon}</span>

                <span className={`${data.class}__text`}>
                  <Typography.H1
                    weight="700"
                    className={`${data.class}__text__number`}
                  >
                    {data.number}
                  </Typography.H1>

                  <Typography.H6
                    className={`${data.class}__text__information`}
                    weight="400"
                  >
                    {data.information}
                  </Typography.H6>
                </span>
              </div>
            ))
          )}
        </section>
      </section>
      <section className="nps-date-one-holder__item">
        <header className="nps-date-one__header">
          <h4>Disparo baseado no canal</h4>
        </header>
        {loadingDataChannelBased ? (
          <div className="nps-date-one-holder__item__loading">
            <Paperplane className="nps-date-one__loading" />
          </div>
        ) : (
          <div className="nps-date-one nps-date-one-col2">
            <div>
              <CardChannelBased
                midiaId={dataChannelBased.sms.midiaId}
                sent={
                  dataChannelBased.sms.sent
                    ? formatNumberToString(dataChannelBased.sms.sent)
                    : "--"
                }
                answered={
                  dataChannelBased.sms.answered
                    ? formatNumberToString(dataChannelBased.sms.answered)
                    : "--"
                }
              />
            </div>
            <div>
              <CardChannelBased
                midiaId={dataChannelBased.email.midiaId}
                sent={
                  dataChannelBased.email.sent
                    ? formatNumberToString(dataChannelBased.email.sent)
                    : "--"
                }
                answered={
                  dataChannelBased.email.answered
                    ? formatNumberToString(dataChannelBased.email.answered)
                    : "--"
                }
              />
            </div>
            <div>
              <CardChannelBased
                midiaId={dataChannelBased.whatsapp.midiaId}
                sent={
                  dataChannelBased.whatsapp.sent
                    ? formatNumberToString(dataChannelBased.whatsapp.sent)
                    : "--"
                }
                answered={
                  dataChannelBased.whatsapp.answered
                    ? formatNumberToString(dataChannelBased.whatsapp.answered)
                    : "--"
                }
              />
            </div>
            <div>
              <CardChannelBased
                midiaId={dataChannelBased.rcs.midiaId}
                sent={
                  dataChannelBased.rcs.sent ? dataChannelBased.rcs.sent : "--"
                }
                answered={
                  dataChannelBased.rcs.answered
                    ? dataChannelBased.rcs.answered
                    : "--"
                }
              />
            </div>
          </div>
        )}
      </section>
    </section>
  );
}
